import React, { Component } from "react";
import { Row, Col, Space, Input, Popconfirm } from "antd";
import { Link } from "react-router-dom";
import { ArrowRightOutlined, LockOutlined } from "@ant-design/icons";
import "../../App.css";

export default class Indie extends Component {
  state = {
    isRight: false,
    isShowPop: false,
    password: "",
  };
  openPop = () => {
    this.setState({ isShowPop: true });
  };
  closePop = () => {
    this.setState({ isShowPop: false, password: "" });
  };
  onPwdChange = (e) => {
    this.setState({ password: e.target.value });
  };
  onSubmit = () => {
    const { password } = this.state;
    if (password === "morna2025") {
      this.setState({ isRight: true });
    } else {
      this.setState({ isShowPop: true });
    }
  };
  render() {
    const { isRight, isShowPop, password } = this.state;
    return (
      <>
        <Row>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
          <Col xs={24} sm={22} md={22} lg={20} xl={20}>
            <Row justify="center">
              <Col span={24} className="paddLR10">
                <Link className="breadCrumbText link" to="/home">
                  Home
                </Link>
                &nbsp;&gt;&nbsp;
                <Link className="breadCrumbText link" to="/gameart">
                  Game Art Projects
                </Link>
              </Col>
              <Col span={24} className="projectTitle">
                Alex's Painter Dream Game Art
              </Col>
              <Col span={24} className="paddTop60"></Col>
            </Row>
          </Col>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
        </Row>
        <Row className="bgColorGray" justify="center">
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
          <Col xs={24} sm={22} md={22} lg={20} xl={20}>
            <Row>
              <Col span={24} className="paddTop40 paddLR10 colCenter">
                {isRight ? (
                  <div className="inputBox colCenter">Developing...</div>
                ) : (
                  <div className="inputBox colCenter">
                    <Space
                      direction="vertical"
                      size="large"
                      className="colCenter"
                    >
                      <div className="lockDiv">
                        <LockOutlined />
                      </div>
                      <Popconfirm
                        description="Password is not right!"
                        open={isShowPop}
                        onConfirm={this.closePop}
                        onCancel={this.closePop}
                        okText="Input Again"
                        showCancel={false}
                      />
                      <Input.Password
                        placeholder="Password!"
                        value={password}
                        maxLength={20}
                        className="inputBar"
                        visibilityToggle={{
                          visible: false,
                          onVisibleChange: this.onSubmit,
                        }}
                        onPressEnter={this.onSubmit}
                        iconRender={() => (
                          <ArrowRightOutlined
                            style={{ color: "rgba(0,0,0,.45)" }}
                          />
                        )}
                        onChange={this.onPwdChange}
                      />
                    </Space>
                  </div>
                )}
              </Col>
              <Col span={24} className="paddTop40"></Col>
            </Row>
          </Col>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
        </Row>
        <Row>
          <Col>
            <div className="rH100"></div>
          </Col>
        </Row>
      </>
    );
  }
}
